export default __webpack_public_path__ + "static/media/ibank.4dbc7c1a.svg";